// AUTO-GENERATED FILE — DO NOT EDIT. Run `bazel run settings-registry`.
//
// Regenerate with `bazel run settings-registry`.

import type { SettingsWrapperManifest } from "./settings-wrapper-manifest.types";

export const settingsWrapperManifest: SettingsWrapperManifest = {
  sections: [
    { id: "advanced-coverage", file: "coverage/coverage.tsx" },
    { id: "checkout-ui-customizations", file: "coverage/coverage.tsx" },
    { id: "commentsold-coverage", file: "coverage/coverage.tsx" },
    {
      id: "customer_widget.appearance",
      file: "customer-widget/tabs/general-tab.tsx",
    },
    { id: "display", file: "coverage/coverage.tsx" },
    { id: "display-options", file: "coverage/coverage.tsx" },
    { id: "dynamic-coverage-transform", file: "coverage/coverage.tsx" },
    { id: "exclusions", file: "coverage/coverage.tsx" },
    { id: "general-coverage", file: "coverage/coverage.tsx" },
    { id: "pre-protected-orders", file: "coverage/coverage.tsx" },
    { id: "redo-item-fulfillment", file: "coverage/coverage.tsx" },
    { id: "return-coverage", file: "coverage/coverage.tsx" },
    { id: "returns.processing", file: "processing.tsx" },
    { id: "returns.ui_barcodes", file: "returns-ui/barcode-card.tsx" },
    {
      id: "returns.ui_external_ra_number",
      file: "returns-ui/external-ra-number-card.tsx",
    },
    {
      id: "returns.ui_gift_receipts",
      file: "returns-ui/gift-receipts-card.tsx",
    },
    {
      id: "returns.ui_item_disposition",
      file: "returns-ui/item-disposition-card.tsx",
    },
    {
      id: "returns.ui_return_details",
      file: "returns-ui/return-details-card.tsx",
    },
    {
      id: "returns.ui_return_editing",
      file: "returns-ui/return-editing-card.tsx",
    },
    { id: "sales-channels", file: "coverage/coverage.tsx" },
    { id: "shopify-cart-validation", file: "coverage/coverage.tsx" },
    {
      id: "support.live_chat_widget",
      file: "customer-widget/tabs/support-tab.tsx",
    },
  ],
  settings: [
    { id: "advanced-options", file: "coverage/coverage.tsx" },
    { id: "cart-validation-function", file: "coverage/coverage.tsx" },
    { id: "channel-selector", file: "coverage/sales-channels-card.tsx" },
    { id: "color", file: "coverage/coverage.tsx" },
    { id: "couponed-items-threshold", file: "coverage/coverage.tsx" },
    {
      id: "coverage-builder",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    { id: "covered-return-methods", file: "coverage/coverage.tsx" },
    { id: "custom-logo", file: "coverage/coverage.tsx", sectionId: "display" },
    {
      id: "customerWidget/general/hideWidgetAfterHours",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customerWidget/general/widgetColor",
      file: "customer-widget/tabs/general-tab.tsx",
      sectionId: "customer_widget.appearance",
    },
    {
      id: "customerWidget/support/messagingHeadingText",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    { id: "delete-cart-properties", file: "coverage/coverage.tsx" },
    {
      id: "dynamic-coverage-transform-function",
      file: "coverage/coverage.tsx",
    },
    { id: "exclude-cent-endings", file: "coverage/coverage.tsx" },
    { id: "exclude-collections", file: "coverage/coverage.tsx" },
    {
      id: "exclude-customer-tags",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-discount-codes",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-in-store-pickup",
      file: "coverage/coverage.tsx",
      sectionId: "general-coverage",
    },
    { id: "exclude-local-pickup", file: "coverage/coverage.tsx" },
    {
      id: "exclude-order-tags",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    { id: "exclude-product-tags", file: "coverage/coverage.tsx" },
    {
      id: "exclude-properties",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    { id: "exclude-skus", file: "coverage/coverage.tsx" },
    {
      id: "exclude-sources",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-variant-metafields",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    { id: "final-sale-returns-coverage", file: "coverage/coverage.tsx" },
    { id: "final-sale-subtext", file: "coverage/coverage.tsx" },
    { id: "final-sale-title-text", file: "coverage/coverage.tsx" },
    { id: "font-size", file: "coverage/coverage.tsx" },
    { id: "info-modal", file: "coverage/coverage.tsx", sectionId: "display" },
    { id: "info-text", file: "coverage/coverage.tsx" },
    { id: "make-sale-items-ineligible", file: "coverage/coverage.tsx" },
    {
      id: "pre-protected-orders",
      file: "coverage/coverage.tsx",
      sectionId: "pre-protected-orders",
    },
    {
      id: "redo-item-fulfillment",
      file: "coverage/coverage.tsx",
      sectionId: "redo-item-fulfillment",
    },
    {
      id: "require-exact-match",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "returns/barcode/bottomDisplayOption",
      file: "returns-ui/barcode-card.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/enabled",
      file: "returns-ui/barcode-card.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/height",
      file: "returns-ui/barcode-card.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/topDisplayOption",
      file: "returns-ui/barcode-card.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/barcode/width",
      file: "returns-ui/barcode-card.tsx",
      sectionId: "returns.ui_barcodes",
    },
    {
      id: "returns/giftReceipts/enabled",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/missingBuyerInfoDescription",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/itemDisposition/enabled",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/gradeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/outcomeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/processing/allowRestockBeforeProcess",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/checkForTryNowTags",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/giftCardOrderProductId",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/hideGiftCardBranding",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/riseTriggerUrl",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/shopAgainAction",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/returnEditing/allowCustomerCancelReturn",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnEditing/allowCustomerEditExchangeAddress",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/ui/aiReviewDefaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/defaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/exposeExternalId",
      file: "returns-ui/external-ra-number-card.tsx",
      sectionId: "returns.ui_external_ra_number",
    },
    {
      id: "returns/ui/lineItemDetailOptions",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/productMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/variantMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "show-on-product-page",
      file: "coverage/coverage.tsx",
      sectionId: "general-coverage",
    },
    { id: "spacing", file: "coverage/coverage.tsx" },
    { id: "subtext-size", file: "coverage/coverage.tsx" },
    { id: "title-text-size", file: "coverage/coverage.tsx" },
  ],
};
